module.exports = __webpack_public_path__ + "img/draw-polygon.49f62607.svg";